import getRowSelectionRenderer from './RowSelection.component';

export default getRowSelectionRenderer;
